import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from "../../../../utilities/automation";

const ButtonContainer = styled.div`
    margin-top: 1.66rem;
    text-align: right;

    @media(max-width:440px) {
        position: fixed;
        z-index: 1004;
        bottom: 0;
        left: 0;
        background-color: ${props => props.theme.primary};
        text-align: center;
        width: 100%;
        border-top: 3px solid ${props => props.theme.secondary};
        padding: 10px;

        .btn{
            width: 75%;
        }

        .btn-primary,.btn-primary:disabled{
            color: #dc3545;
            background-color: transparent !important;
            background-image: none;
            border-color: #dc3545;

            color: white;
        }
    }
`;
export default (props) => {
    const { toggleButton, formLoading, handleSubmit, show } = props;
    const { lang } = useLanguage();
    if (!show) {
        return (
            <ButtonContainer>
                <Button data-test-id={createDataTestId({feature: AutomationTestIdFeature.MRQT_CALCULATOR, element: AutomationTestIdElementType.BUTTON, specifier: 'updateResults'})} className="macu-btn small inverse w-100 mrqt-update-results py-2" disabled={toggleButton || formLoading} type="button" onClick={handleSubmit}>{getTranslation(lang).updateResults}</Button>
            </ButtonContainer>
        );
    } else {
        return null;
    }

};